export class Logger {
  static get debug() {
    return console.debug.bind(window.console);
  }

  static get log() {
    return console.log.bind(window.console);
  }

  static get warn() {
    return console.warn.bind(window.console);
  }

  static get error() {
    return console.error.bind(window.console);
  }
}
